module.exports = __webpack_public_path__ + "47fa543a.png";